import { lazy } from 'react'

export const KitNotAloneV1 = lazy(() => import('./kitV1/KitNotAloneV1'))
